var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5Z",
    stroke: "#147F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2218 6.10312C17.4593 6.32187 17.6843 6.54687 17.8968 6.77812L20.4562 7.14374C20.8732 7.86797 21.1946 8.64317 21.4124 9.44999L19.8562 11.5219C19.8562 11.5219 19.8843 12.1594 19.8562 12.4781L21.4124 14.55C21.1956 15.3572 20.8741 16.1325 20.4562 16.8562L17.8968 17.2219C17.8968 17.2219 17.4562 17.6812 17.2218 17.8969L16.8562 20.4562C16.1319 20.8733 15.3567 21.1947 14.5499 21.4125L12.478 19.8562C12.1599 19.8844 11.8399 19.8844 11.5218 19.8562L9.4499 21.4125C8.64274 21.1957 7.8674 20.8742 7.14365 20.4562L6.77803 17.8969C6.54678 17.6781 6.32178 17.4531 6.10303 17.2219L3.54365 16.8562C3.12664 16.132 2.80521 15.3568 2.5874 14.55L4.14365 12.4781C4.14365 12.4781 4.11553 11.8406 4.14365 11.5219L2.5874 9.44999C2.8042 8.64283 3.12568 7.8675 3.54365 7.14374L6.10303 6.77812C6.32178 6.54687 6.54678 6.32187 6.77803 6.10312L7.14365 3.54374C7.86788 3.12673 8.64308 2.8053 9.4499 2.58749L11.5218 4.14374C11.8399 4.11561 12.1599 4.11561 12.478 4.14374L14.5499 2.58749C15.3571 2.80429 16.1324 3.12577 16.8562 3.54374L17.2218 6.10312Z",
    stroke: "#147F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.1c414a91ba2a78ba534923d957ab1e85.svg";
export { ForwardRef as ReactComponent };